import firebase from 'firebase';
import { db, storage } from '@/firebase'

export default {
    firebaseRegister: ({ commit }, user) => {
        return firebase.auth().createUserWithEmailAndPassword(user.email, user.password);
    },
    firebaseLogin: ({ commit }, user) => {
        let _vm = this
        return firebase.auth().signInWithEmailAndPassword(user.email, user.password)
            .then((user) => {
                return db.collection('users').doc(user.user.uid).get()
                    .then((doc) => {
                        let user_db = {};
                        if (doc.exists) {
                            user_db = doc.data();

                        }
                        //reducir el objeto user a lo necesario
                        var array_promesas = [];
                        let user_combinado = { ...user.user, ...user_db };
                        commit('setUser', user_combinado);

                        /*let p_users_auth = _vm.$store.dispatch('users/getUsuariosCall');
                        let p_users = _vm.$store.dispatch('users/getUsuarios');
                        let p_negocios = _vm.$store.dispatch('negocios/getNegocios');
                        let p_caracteristicas = _vm.$store.dispatch('caracteristicas/getCaracteristicas');
        
                        return Promise.all([p_negocios,p_caracteristicas]);    */
                    })
            })
    },
    firebaseLogout: ({ commit, dispatch }) => {
        return firebase.auth().signOut()
            .then(() => {
                commit('logout');
                return dispatch('app/resetSistema', {}, { root: true })

            })
            .catch((e) => {
                console.log(e);
            })
    },
    getMensajes({ commit, state }) {
        db.collection('users').doc(state.user.uid).collection('mensajes')
            .orderBy('fecha', 'desc')
            .onSnapshot((doc) => {
                var res = [];
                doc.forEach((d) => {
                    res.push({
                        ...d.data(),
                        id: d.id
                    })
                })
                commit('setMensajes', res)
            })
    },
    marcarMensajeLeido({ commit, state }, id) {
        return db.collection('users').doc(state.user.uid).collection('mensajes')
            .doc(id).set({
                leido: true,
                fechaLeido: firebase.firestore.FieldValue.serverTimestamp()
            }, { merge: true })
    },
    eliminarMensaje({ commit, state }, item) {
        var promesas = [];
        promesas.push(
            db.collection('users').doc(state.user.uid).collection('mensajes')
                .doc(item.id).delete(),
        )
        if (item.file) {
            var destino = item.file;
            var stRef = storage.ref(destino);

            promesas.push(stRef.delete().then(function () {
            }).catch(function (error) {
            }))
        }
        return Promise.all(promesas).then(() => { return { ok: true } })
    }
}